import React from 'react';
import Error, { hasNamedError } from '../commons/component/error';
import Recaptcha from '../commons/component/captcha/recaptcha';
import InputNumber from '../commons/component/input-number';
import AempUserIcon from '../icons/aemp-user-icon';
import { pushOrRedirect } from '../commons/query';
import Button from '../commons/component/button';
import config from '../generated/config';
import { dispatchMetric } from '../metrics';
import { getEventPayload } from '../metrics/metrics.selector';
import { getCustomerQualifyerData } from './customer-qualifyer';

const FORM_FIELDS = ['cnpj'];

const HTTP_BAD_REQUEST = 400;
const DOCUMENT_MAX_LENGTH = 18;

const { url } = config;

export default class CadastroPjDocumentComponent extends React.Component {
  state = {
    isFormSubmitting: false,
    errors: {},
    company: { cnpj: this.props.formDataState.cnpj }
  };

  render() {
    const { errors } = this.state;

    return (
      <div>
        <div className="cadastroHeader">
          <h2 className="cadastroForm-title">
            <AempUserIcon />
            <span>cadastro</span>
          </h2>
          <p className="cadastroSubtitle">
            para iniciar o cadastro da sua empresa, insira o seu CNPJ e valide suas informações.
          </p>
        </div>
        <form className="cadastroForm" onSubmit={this.handleSubmit}>
          <div className="inputGroup --marginBottomMd" id="cnpj">
            <label className="inputGroup-label --acronym" htmlFor="cnpj-input">
              cnpj
            </label>
            <InputNumber
              name="cnpj"
              id="cnpj-input"
              data-page="signup"
              data-form="signup"
              onChange={this.changeField('cnpj')}
              value={this.state.company.cnpj}
              className={`inputGroup-input ${this.hasError('cnpj')}`}
              type="text"
              mask="__.___.___/____-__"
              placeholder="Ex: 12.345.678/1234-56"
              disabled={this.state.isFormSubmitting}
              required
            />
            <Error errors={errors} name="cnpj" />
          </div>
          {config.enableCaptchaOnPJRegister && <Recaptcha ref={ref => (this.captcha = ref)} />}

          <div className="cadastro-buttons">
            <Button
              primary
              disabled={this.state.isFormSubmitting}
              loading={this.state.isFormSubmitting}
              className="cadastroForm-submit"
            >
              continuar
            </Button>
            <button
              className="btn button-ghost"
              disabled={this.state.isFormSubmitting}
              onClick={this.goBack}
            >
              voltar
            </button>
          </div>
        </form>
      </div>
    );
  }

  handleSubmit = async evt => {
    evt.preventDefault();
    this.setState({ isFormSubmitting: true });

    const { submitHandler, formDataState, setCadastroPjDocumentState, currentStep } = this.props;

    const eventType = 'event_signup';

    const metricPayload = {
      event: eventType,
      eventCategory: 'tela-cadastro-etapa-1',
      eventAction: 'continuar'
    };

    const metricEventPayload = getEventPayload({ ...metricPayload });

    try {
      dispatchMetric(eventType, {
        payload: {
          eventLabel: 'sucesso',
          ...metricEventPayload
        }
      });
      await submitHandler(
        this.state.company,
        FORM_FIELDS,
        this.captcha,
        formDataState,
        setCadastroPjDocumentState,
        currentStep
      );
    } catch (errors) {
      dispatchMetric(eventType, {
        payload: {
          eventLabel: 'erro:campo-invalido',
          ...metricEventPayload
        }
      });
      console.log('errors', errors);
      this.setState({ errors, isFormSubmitting: false });
    }
  };

  hasError(name) {
    return hasNamedError(name, this.state.errors) ? '--hasError' : '';
  }

  changeField(name) {
    return e =>
      this.setState(
        {
          company: {
            ...this.state.company,
            [name]: e.target.value
          }
        },
        this.updateDocumentState
      );
  }

  async updateDocumentState() {
    const { cnpj = '' } = this.state.company;
    this.setState({ company: { cnpj } });

    if (cnpj.length === DOCUMENT_MAX_LENGTH) {
      this.setState({ isFormSubmitting: true });
      this.props.setCadastroPjDocumentState({ customerQualifyerData: {} });
      const customerQualifyerData = await getCustomerQualifyerData(this.state.company.cnpj);
      this.props.setCadastroPjDocumentState({ customerQualifyerData });

      if (customerQualifyerData.success) {
        this.setState({
          company: {
            ...this.state.company,
            corporateName: customerQualifyerData.company.corporateName || '',
            fantasyName: customerQualifyerData.company.fantasyName || ''
          },
          errors: {},
          isFormSubmitting: false
        });
      } else {
        if (customerQualifyerData.response) {
          const { status } = customerQualifyerData.response;
          this.setState({
            isFormSubmitting: false,
            errors: {}
          });
          if (status === HTTP_BAD_REQUEST) {
            this.setState({
              errors: {
                cnpj:
                  status === HTTP_BAD_REQUEST
                    ? 'CNPJ inválido.'
                    : 'Este CNPJ não se encontra ativo/válido na Receita Federal.'
              }
            });
          }
        }
      }
    }
  }

  goBack = event => {
    event.preventDefault();
    pushOrRedirect(null, {
      url: url.login
    });
  };
}
